module.exports = "<div [id]=\"viewerId\" class=\"reportContainer\"></div>"